import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NotFoundIcon, HomeIcon, LeftArrowIcon } from './Icons';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-icon">
          <NotFoundIcon width="120" height="120" />
        </div>
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">页面未找到</h2>
        <p className="not-found-description">
          抱歉，您访问的页面不存在或已被移除。
        </p>
        <div className="not-found-actions">
          <button 
            className="go-home-button"
            onClick={handleGoHome}
          >
            <HomeIcon width="20" height="20" />
            返回首页
          </button>
          <button 
            className="go-back-button"
            onClick={() => window.history.back()}
          >
            <LeftArrowIcon width="20" height="20" />
            返回上页
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
